/* Product page: flavor switcher + gallery. Swaps photos, price, details and the
   form's variant without a page load, and keeps ?variant= in the URL so links
   and the Kaching bundle widget stay in sync. */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var root = document.getElementById('product');
    if (!root) return;
    var input = root.querySelector('[data-variant-input]');
    /* the price line only (the flavor buttons carry data-price too, and the price
       line is hidden in pre-launch mode, so a bare [data-price] would grab a button) */
    var priceEl = root.querySelector('.pdp-price[data-price]');
    var nameEl = root.querySelector('[data-flavor-name]');
    var addBtn = root.querySelector('[data-add]');
    var addLabel = root.querySelector('[data-add-label]');
    var addText = addLabel ? addLabel.textContent : 'Add to bag';
    var buttons = [].slice.call(root.querySelectorAll('.pdp-flavor'));

    /* gallery: thumbnails switch the main photo within the visible set */
    root.querySelectorAll('.pdp-set').forEach(function (set) {
      var slides = [].slice.call(set.querySelectorAll('.pdp-slide'));
      var thumbs = [].slice.call(set.querySelectorAll('.pdp-thumb'));
      var cap = set.querySelector('.pdp-frame-cap');
      function show(i) {
        slides.forEach(function (s, n) { s.hidden = n !== i; });
        /* the polaroid caption follows the photo (flavor name, "Our duo", ...) */
        if (cap && slides[i]) cap.textContent = slides[i].dataset.cap || '\u00a0';
        thumbs.forEach(function (t, n) { t.setAttribute('aria-current', String(n === i)); });
        var img = slides[i] && slides[i].querySelector('img');
        if (img) img.loading = 'eager';
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { show(+t.dataset.go); });
      });
      /* swipe on the main photo */
      var main = set.querySelector('.pdp-main'), x0 = null, cur = function () {
        for (var n = 0; n < slides.length; n++) if (!slides[n].hidden) return n;
        return 0;
      };
      if (main) {
        main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0; x0 = null;
          if (Math.abs(dx) < 50) return;
          var n = cur() + (dx < 0 ? 1 : -1);
          if (n >= 0 && n < slides.length) show(n);
        });
      }
    });

    function select(btn, pushUrl) {
      var key = btn.dataset.key, id = btn.dataset.variant, available = btn.dataset.available === 'true';
      buttons.forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
      root.querySelectorAll('[data-set]').forEach(function (el) { el.hidden = el.dataset.set !== key; });
      root.querySelectorAll('[data-panel]').forEach(function (el) { el.hidden = el.dataset.panel !== key; });
      if (priceEl) priceEl.textContent = btn.dataset.price;
      if (nameEl) nameEl.textContent = btn.dataset.title || btn.textContent.trim();
      if (addBtn) {
        addBtn.disabled = !available;
        if (addLabel) addLabel.textContent = available ? addText : 'Sold out';
      }
      if (input && input.value !== id) {
        input.value = id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (pushUrl) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', id);
        window.history.replaceState({}, '', url.toString());
      }
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variantId: Number(id) } }));
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () { select(btn, true); });
    });

    /* ?bundle=single|duo|gift (from the homepage cards) preselects that Kaching
       option. Kaching renders after load, so wait for its bars; they're in
       order: Single Balm, 2 Balm Set, 4-pack / gift set. */
    var BARS = { single: 0, duo: 1, gift: 2 };
    var want = new URL(window.location.href).searchParams.get('bundle');
    if (want && Object.prototype.hasOwnProperty.call(BARS, want)) {
      var tries = 0, picked = false;
      (function pick() {
        var bars = document.querySelectorAll('kaching-bundles-block label.kaching-bundles__bar-container');
        var bar = bars[BARS[want]];
        if (bar) {
          var radio = bar.querySelector('input[type=radio]') ||
            (bar.previousElementSibling && bar.previousElementSibling.matches('input[type=radio]') ? bar.previousElementSibling : null);
          if (!radio || !radio.checked) bar.click();
          /* check once more in case Kaching re-renders after syncing the flavor */
          if (!picked) { picked = true; setTimeout(pick, 600); }
          return;
        }
        if (++tries < 60) setTimeout(pick, 100);
      })();
    }
  });
})();
